import { Component, OnInit } from "@angular/core";
import { AppService } from "src/app/core/services/app.service";
import { OOVenueService } from "src/app/core/services/venue-service";

@Component({
	selector: "app-contract-finance",
	templateUrl: "./contract-finance.component.html",
	styleUrls: ["../commandcenter.scss"],
})
export class ContractFinanceComponent implements OnInit {
	constructor(public app: AppService, public venueService: OOVenueService) {}

	ngOnInit(): void {
		this.venueService.subscriptionVenue.subscribe((venue) => {
			if (venue.contractFinanceEnabled && !this.venueService.venueFinance.value.venueKey) {
				this.venueService.venueFinanceInit();
			}
		});
		// if (this.venueService.subscriptionVenue.value.contractFinanceEnabled && !this.venueService.venueFinance.value.venueKey) {
		// 	this.venueService.venueFinanceInit();
		// }
	}
}
